module.exports = __webpack_public_path__ + "img/Logo-Cobro.71a38b3e.png";